import PropTypes from 'prop-types';
import { useState, useEffect, useCallback } from 'react';

import { paths } from 'src/routes/paths';
import { useRouter } from 'src/routes/hooks';

import Paywall from 'src/components/paywall';
import { SplashScreen } from 'src/components/loading-screen';

import { useAuthContext } from '../hooks';
import { hasPaidAccess } from './has-paid-access';

// ----------------------------------------------------------------------

export default function AuthGuard ({ children }) {
  const { loading } = useAuthContext();

  return <>{loading ? <SplashScreen /> : <Container> {children}</Container>}</>;
}

AuthGuard.propTypes = {
  children: PropTypes.node,
};

// ----------------------------------------------------------------------

function Container ({ children }) {
  const router = useRouter();

  const { isAuthenticated, user } = useAuthContext();

  const [checked, setChecked] = useState(false);

  const check = useCallback(() => {
    if (!isAuthenticated) {
      const { pathname, search } = window.location;
      const returnTo = `${pathname}${search}`; // Combine path and query params

      const searchParams = new URLSearchParams({
        returnTo,
      }).toString();

      const loginPath = paths.auth.login;

      const href = `${loginPath}?${searchParams}`;

      router.replace(href);
    } else {
      setChecked(true);
    }
  }, [isAuthenticated, router]);

  useEffect(() => {
    check();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  if (!checked) {
    return null;
  }

  // Show paywall for unpaid/inactive users (except on certain pages)
  const currentPath = window.location.pathname;
  const isAccountPage = currentPath.startsWith('/account');
  const isPaymentSuccessPage = currentPath.startsWith('/payment-success');

  if (!hasPaidAccess(user) && !isAccountPage && !isPaymentSuccessPage) {
    return <Paywall />;
  }

  return <>{children}</>;
}

Container.propTypes = {
  children: PropTypes.node,
};
